import { Button, Row, Col, Input, Label, FormGroup, FormFeedback } from "reactstrap";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { memo, useState } from "react"
import { useFormikContext } from 'formik';
import { isNonNegativeInt } from "../../utils/validation";
import useErrorHandler from "../../utils/Hooks/ErrorHandler";
import { FormLabel, FormValue } from '../Form/FormLabel';
import { endpoints } from "../../utils/Constants"
import { useAuth } from "../../Services/AuthContext"
import { useAlert } from '../../Services/AlertContext';
import { useHistory } from 'react-router-dom';

const UpdateMargin = (props) => {

    const { values } = useFormikContext();
    const currentMargin = values.withMargin - values.price;
    const { route, toggle } = { ...props };
    const [newMargin, setNewMargin] = useState(currentMargin);
    const { error, showError } = useErrorHandler(null);
    const [auth] = useAuth();
    const alert = useAlert();
    const [marginType, setMarginType] = useState("0")
    const isMarginTypePercent = marginType === "1";
    //const [state, dispatch] = useState(true);
    const { push } = useHistory();
    const closeBtn = (
        <button onClick={props.toggle} className="close" type="button">
            &times;
        </button>
    );

    const validatMargin = (
        margin
    ) => {
        // Validate margin
    if (!isNonNegativeInt(margin?.toString())) {
            showError("Please enter a valid margin.");
            //setShowError(true)
            return false;
        }
        if (!isMarginTypePercent && margin === currentMargin) {
            showError('Same Margin.')
            //setShowError(true)
            return false;
        }
        return true;
    };

    const handleSubmit = (e) => {

        e.preventDefault();
        //setLoading(true);
        if (validatMargin(newMargin)) {
            const post = {
                jobReference: values.jobReference,
                newMargin: newMargin,
                oldMargin: currentMargin,
                id: values.id,
                bidHistoryId: values?.bid?.id,
                bidderId: values?.bid?.bidderId,
                marginType: marginType
            }
            const headers = {
                'Content-type': 'application/json',
                'Authorization': `Bearer ${auth.jwt}`
            }
            fetch(endpoints.marginUpdateAdmin, { method: 'POST', headers: headers, body: JSON.stringify(post) }).then((result) => {

                const saveMessage = (result?.ok) ? `Margin Updated for JB${values.jobReference}` : "Error Occured in Updating Margin";
                alert({
                    title: "Margin Update", body: <div>
                        {saveMessage}
                    </div>
                    , onDismiss: () => {
                        push(route);
                        toggle();
                    },
                    modalSize: "md"
                })

            }, (error) => {
                alert({ title: 'Margin Update', body: "Error Occured in Updating Margin" + error ? JSON.stringify(error) : 'No Error!', modalSize: "md" });
                console.log(JSON.stringify(error))
            })
            // props.toggle()
        }

        return false
    }

    const handleNewMarginChange = (e) => {
        if (e.target.value) {
            const value = Math.max(0, Math.min(isMarginTypePercent ? 100 : values.price, Number(e.target.value)));
            setNewMargin(value)
        }
        else {
            setNewMargin(0)
        }
    }
    const onMarginTypeChange = (e) => {

        setMarginType(e.currentTarget.value)
        if (e.currentTarget.value === "0") {
            setNewMargin(currentMargin)
        }
        else
            setNewMargin(0)
    }

    return (
        <>
            <Modal isOpen={props.modal} toggle={toggle} backdrop={"static"} fade={false} unmountOnClose>
                <ModalHeader toggle={props.toggle} close={closeBtn} style={{ backgroundColor: 'lightblue' }}>
                    Update Margin for JB{values.jobReference}
                </ModalHeader>
                <ModalBody>

                    <Row>
                        <Col>
                            <FormGroup>
                                <FormLabel htmlFor="price" style={{ display: 'block' }}>Price</FormLabel>
                                <FormValue htmlFor="price" style={{ display: 'block' }}>{values.price}</FormValue>
                            </FormGroup>

                        </Col>
                        <Col>
                            <FormGroup>
                                <FormLabel htmlFor="withMargin" style={{ display: 'block' }}>WithMargin</FormLabel>
                                <FormValue htmlFor="withMargin" style={{ display: 'block' }}>{values.withMargin}</FormValue>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <FormLabel htmlFor="Margin" style={{ display: 'block' }}>Margin</FormLabel>
                                <FormValue htmlFor="Margin" style={{ display: 'block' }}>{currentMargin}</FormValue>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row className="align-items-center">
                        <Col md={4}>
                            <FormGroup>
                                <Label for="MarginType">
                                    <b> Margin Type</b>
                                </Label>
                                <Input
                                    id="MarginType"
                                    name="MarginType"
                                    type="select" value={marginType}
                                    onChange={onMarginTypeChange}  >
                                    <option value="0">
                                        Fixed
                                    </option>
                                    <option value="1">
                                        Percentage
                                    </option>

                                </Input>
                            </FormGroup>
                        </Col>
                        <Col md={4}>
                            <FormGroup>
                                <Label for="NewMargin">
                                    <b>New Margin</b>
                                </Label>
                                <Input invalid={error ? true : false} placeholder="Enter New Margin" id='NewMargin' name='NewMargin' type="number"
                                    onChange={handleNewMarginChange} value={newMargin} />
                                <FormFeedback>
                                    {error}
                                </FormFeedback>
                            </FormGroup>
                        </Col>

                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={handleSubmit} >
                        Update
                    </Button>{' '}
                    <Button color="secondary" onClick={props.toggle}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    )
}
export default memo(UpdateMargin);